import { useMemo } from 'react'
import { useReportGraphContext } from '../context/useReportGraph'
import useTickers from '../../../hooks/useTickers'
import LegendButton from '../../../components/Graphs/LegendButton'
import Tooltip from '../../../components/Tooltip'
import styles from './ReportGraph.module.scss'

const ReportGraphLegend = () => {
    const { tickers } = useTickers()
    const { activeLegendTickers, graphs, handleLegendClick } = useReportGraphContext()

    const labels = useMemo(() => {
        return tickers && Array.from(new Set(graphs.flatMap(item => ({label: item.ticker, color:item.color, name: tickers?.find(ticker => ticker.value === item.ticker)?.name ?? item.ticker}))))
    },[graphs, tickers])

    return (
        <div className={styles['legends']}>
            {labels.map(({label, color, name}) => {
                const isActive = activeLegendTickers.includes(label)
                return <Tooltip title={name}>
                    <div>
                        <LegendButton 
                            key={`${label}-${color}`}
                            handleClick={handleLegendClick}
                            name={name}
                            color={color}
                            shouldDisplay={isActive}
                            largeMode={isActive}
                            onClickData={label}
                        />
                    </div>
                </Tooltip>
            })}
        </div>
    )
}

export default ReportGraphLegend